import React from 'react';
import { Badge } from 'antd';
import { BadgeProps as BadgeCopyProps } from 'antd/lib/badge';

export type BadgeProps = BadgeCopyProps;

const ProBadge: React.FC<BadgeProps> = (props) => {
  const { children, ...resProps } = props;

  return <Badge {...resProps}>{children}</Badge>;
};

export default ProBadge;
